import { getCookie, splitAddress } from "../util";
import { HttpClient } from "./httpClient";
import axios from "axios";
import { isEmpty, get } from "lodash";
import moment from "moment-timezone";
import { showToast } from "../CBP_App/util/showToast";

const API_URL = window._env_.REACT_APP_BROKER_API_URL;
const isBroker = true;

const getRequestHeadersNoToken = () => {
  return {
    Accept: "application/json",
    "Content-Type": "application/json",
  };
};

const convertToEpoch = function (value) {
  moment.tz.add(
    "America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5"
  );

  let entityTimezone = "America/Toronto";
  let time = new Date(value).getTime();

  const localTime = moment(value);
  const timeZoneTime = moment(value).tz(entityTimezone);
  let modifiedDate = moment(value);

  modifiedDate.subtract(
    -localTime.utcOffset() + timeZoneTime.utcOffset(),
    "minutes"
  );

  return modifiedDate.valueOf();
};

export default {
  login: function (email, password) {
    return fetch(API_URL, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "post",
      body: JSON.stringify({
        eventMessage: {
          email: email,
          hashedPassword: password,
          typeOfUser: "BROKER_USER",
        },
        eventType: "KXUSER_LOGIN",
        eventTime: Date.now(),
      }),
    });
  },

  sendKnEmail: (body) => {
    const data = {
      eventMessage: body,
      eventType: "SET_AUTH_TOKEN",
      eventTime: Date.now(),
    };
    return HttpClient.custom({ data });
  },

  authenticateGeneratedOTP: (body) => {
    const data = {
      eventMessage: body,
      eventType: "VALIDATE_AUTH_TOKEN",
      eventTime: Date.now(),
    };
    return HttpClient.custom({ data });
  },

  forgot: function (email) {
    return fetch(API_URL, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "post",
      body: JSON.stringify({
        eventMessage: {
          email: email,
          typeOfUser: "BROKER_USER",
        },
        eventType: "RESET_PASSWORD",
        eventTime: Date.now(),
      }),
    });
  },

  reset: function (kxBrokerToken, password) {
    return fetch(API_URL, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        kxToken: kxBrokerToken,
      },
      method: "post",
      body: JSON.stringify({
        eventMessage: {
          userBasicInfo: {
            typeOfUser: "CUSTOMER_USER",
            hashedPassword: password,
          },
        },
        eventType: "UPDATE_PASSWORD",
        eventTime: Date.now(),
      }),
    });
  },

  // Need to keep companyAddress and companyInfo the same (until Alok can fix this issue)
  companyInfo: function (
    kxToken,
    companyName,
    businessName,
    address,
    address2,
    city,
    state,
    zip,
    country,
    entryMin,
    entryMax
  ) {
    return fetch(API_URL, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        kxToken: kxToken,
      },
      method: "post",
      body: JSON.stringify({
        eventMessage: {
          userBasicInfo: {
            companyName: companyName,
          },
          userInfo: {
            companyInformation: {
              businessName: businessName,
              businessAddress: [
                {
                  type: "STREET_NUMBER",
                  information: address,
                },
                {
                  type: "STREET_NAME",
                  information: address2,
                },
                {
                  type: "COUNTRY_SUB_ENTITY",
                  information: state,
                },
                {
                  type: "CITY",
                  information: city,
                },
                {
                  type: "COUNTRY",
                  information: country,
                },
                {
                  type: "POSTAL_CODE",
                  information: zip,
                },
              ],
            },
          },
          entryNumberDetails: {
            startRange: parseInt(entryMin),
            endRange: parseInt(entryMax),
            runningIndex: parseInt(entryMin),
          },
        },
        eventType: "KXUSER_UPDATE_COMPANY_INFO",
        eventTime: Date.now(),
      }),
    });
  },

  bondInfo: function (kxToken, suretyNumber, bondAmount, bondOwner, bondType) {
    return fetch(API_URL, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        kxToken: kxToken,
      },
      method: "post",
      body: JSON.stringify({
        eventMessage: {
          userInfo: {
            bondInfo: {
              suretyNumber: suretyNumber,
              bondAmount: bondAmount,
              bondOwner: bondOwner,
              bondType: bondType,
            },
          },
        },
        eventType: "KXUSER_UPDATE_BOND_INFO",
        eventTime: Date.now(),
      }),
    });
  },
  getUserInfo: function (kxToken) {
    return Promise.all([
      fetch(API_URL, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          kxToken: kxToken,
        },
        method: "post",
        body: JSON.stringify({
          eventType: "GET_KXUSER",
          eventMessage: {},
          eventTime: Date.now(),
        }),
      }),
      fetch(API_URL, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          kxToken: kxToken,
        },
        method: "post",
        body: JSON.stringify({
          eventType: "GET_TEAM_MEMBERS",
          eventMessage: {},
          eventTime: Date.now(),
        }),
      }),
      fetch(API_URL, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          kxToken: kxToken,
        },
        method: "post",
        body: JSON.stringify({
          eventType: "GET_CHANNEL_CONNECTIONS",
          eventMessage: {},
          eventTime: Date.now(),
        }),
      }),
    ]);
  },

  getKxuser: function (kxToken) {
    return fetch(API_URL, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        kxToken: kxToken,
      },
      method: "post",
      body: JSON.stringify({
        eventType: "GET_KXUSER",
        eventMessage: {},
        eventTime: Date.now(),
      }),
    });
  },

  uploadDocument: (bucketName, formData) => {
    let config = {
      url: `${window._env_.REACT_APP_MEDIA_URL}/${bucketName}`,
      headers: {
        'Content-type': 'application/json',
        Accept: 'application/json',
      },
      data: formData,
      method: 'post',
    };
    axios.defaults.baseURL = `${window._env_.REACT_APP_MEDIA_URL}/${bucketName}`;
    config.method = config.method;
    axios.defaults.headers.common['Accept'] = config.headers["Accept"];
    axios.defaults.headers.common['Content-Type'] = config.headers["Content-Type"];
    const isLoginPage = document.getElementById('txtInputName');
    if (!isLoginPage) {
      axios.defaults.headers.common['kxToken'] = getCookie(window.GLOBAL_MAIN_TOKEN_KXBROKERTOKEN);
    }
    return axios(config);
  },

  archeiveStatement: function (statementNumber) {
    const data = {
      eventMessage: {
        value: statementNumber,
      },
      eventType: "ARCHIVE_STATEMENT",
      eventTime: Date.now(),
    };
    return HttpClient.custom({
      data,
    });
  },
  getCountryList: function (kxToken) {
    return fetch(API_URL, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        kxToken: getCookie(window.GLOBAL_MAIN_TOKEN_KXBROKERTOKEN),
      },
      method: "post",
      body: JSON.stringify({
        eventType: "GET_HS_MASTER_HS",
        eventMessage: {
          country: "CA",
          hsVersion: "2019Rev2.0",
          itemType: "COUNTRY_LIST",
        },
        eventTime: Date.now(),
      }),
    });
  },

  addCreditCard: function (
    kxToken,
    cardType,
    cardHolder,
    cardNumber,
    cvv,
    expMonth,
    expYear,
    isPreferred
  ) {
    return fetch(API_URL, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        kxToken: getCookie(window.GLOBAL_MAIN_TOKEN_KXBROKERTOKEN),
      },
      method: "post",
      body: JSON.stringify({
        eventMessage: {
          creditCardDetails: [
            {
              type: cardType,
              fullName: cardHolder,
              cardNumber: cardNumber,
              cvv: cvv,
              expMonth: expMonth,
              expYear: expYear,
              isPreferred: false,
              purpose: ["PAYMENT_PURPOSE_ISF_FEE", "PAYMENT_PURPOSE_CBP"],
            },
          ],
        },
        eventType: "PAYMENT_CREATE_CREDIT_CARD",
        eventTime: Date.now(),
      }),
    });
  },

  addACH: function (
    kxToken,
    accountOwner,
    accountNumber,
    routingNumber,
    bankName,
    bankCity,
    bankState,
    bankCountry,
    isPreferred
  ) {
    return fetch(API_URL, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        kxToken: kxToken,
      },
      method: "post",
      body: JSON.stringify({
        eventMessage: {
          bankDetails: [
            {
              type: "CHECKING",
              fullName: accountOwner,
              accountNumber: accountNumber,
              routingNumber: routingNumber,
              bankName: bankName,
              bankCity: bankCity,
              state: bankState,
              country: bankCountry,
              isPreferred: false,
              purpose: ["PAYMENT_PURPOSE_ISF_FEE", "PAYMENT_PURPOSE_CBP"],
            },
          ],
        },
        eventType: "PAYMENT_CREATE_BANK_DETAILS",
        eventTime: Date.now(),
      }),
    });
  },

  getPaymentHistory: function (kxToken, paymentGuid, low, high, pageDirection) {
    return fetch(API_URL, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        kxToken: kxToken,
      },
      method: "post",
      body: JSON.stringify({
        eventType: "PAYMENT_GET_HISTORY",
        eventMessage: {
          paymentGuid: paymentGuid,
          low: low,
          high: high,
          pageDirection: pageDirection,
        },
        eventTime: Date.now(),
      }),
    });
  },


  generatePDF: function (shipmentID, type = "CLIENT_PDF_ES") {
    if (!type) {
      return;
    }
    const data = {
      eventMessage: {
        shipmentId: shipmentID,
        pdfType: type,
        signDate: `${((new Date().getMonth() + 1) + "").padStart(2, '0')}${(new Date().getDate() + "").padStart(2, '0')}${((new Date().getFullYear() % 100) + "").padStart(2, '0')}`,
      },
      eventType: "GENERATE_PDF",
      eventTime: Date.now(),
    };
    return HttpClient.custom({
      data,
    });
  },

  getDailyPreAuth: function (
    filerCode,
    pageNumber = 1,
    keyword = "",
    state,
    applyClicked,
    eventId,
    isEngine
  ) {
    let {
      auth,
      unauth,
      archived,
      brokerFilerFilter,
      fromDateFilter,
      toDateFilter,
      typeSelected,
      searchApplied,
      poFilter,
      portFilter,
      country,
      transactionNoFilter,
      groupBy,
    } = state;
    let paymentTab = "";

    if (auth === true && unauth === true)
      paymentTab = "PAYMENT_STATEMENT_ALL_TAB";
    else if (auth === false && unauth === true)
      paymentTab = "PAYMENT_STATEMENT_UNAUTH_TAB";
    else if (auth === true && unauth === false)
      paymentTab = "PAYMENT_STATEMENT_AUTH_TAB";
    else if (archived === true) paymentTab = "PAYMENT_STATEMENT_ARCHIVED_TAB";
    else paymentTab = "PAYMENT_STATEMENT_ALL_TAB";

    let eventType = "GET_CBP_STATEMENTS_FOR_CUSTOMER_OPS";

    if (isBroker) {
      eventType = "GET_CBP_STATEMENTS_FOR_BROKER";
    }

    if (searchApplied) {
      eventType = "GET_CBP_STATEMENTS_BY_FILER_CODE";
    }

    if (country === "canada") {
      eventType = "GET_CBSA_STATEMENTS_FOR_BROKER";
    }

    // if(fromDateFilter === null && toDateFilter === null) {
    //   fromDateFilter = defaultStartDate;
    //   toDateFilter = defaultEndDate;
    // }

    const data = {
      eventId,
      eventType,

      eventMessage: {
        filerCode,
        pageNumber: pageNumber,
        keyword: keyword,
        paymentTab,
        isDaily: typeSelected === "DAILY",
        advanceSearchKey: brokerFilerFilter,
        transactionNumber: transactionNoFilter,
        po: poFilter,
        port: portFilter,
        startTime: fromDateFilter ? convertToEpoch(fromDateFilter) : null,
        endTime: toDateFilter
          ? convertToEpoch(toDateFilter) + (24 * 60 * 60 * 1000 - 1)
          : null,
        groupBy: groupBy,
      },
      eventTime: Date.now(),
    };
    if (isEngine) {
      data.eventMessage.requestType = 'engine';
    }
    if (isBroker) {
      delete data.eventMessage.advanceSearchKey;
    }

    if (country === "canada") {
      delete data.eventMessage.paymentTab;
      if (!searchApplied) {
        delete data.eventMessage.po;
        delete data.eventMessage.port;
        delete data.eventMessage.transactionNumber;
        // delete data.eventMessage.startTime;
        // delete data.eventMessage.endTime;
      }

      if (!data.eventMessage.po) delete data.eventMessage.po;

      if (!data.eventMessage.port) delete data.eventMessage.port;

      if (!data.eventMessage.transactionNumber)
        delete data.eventMessage.transactionNumber;

      if (!data.eventMessage.startTime) delete data.eventMessage.startTime;

      if (!data.eventMessage.endTime) delete data.eventMessage.endTime;
    }

    if (country !== "canada") {
      delete data.eventMessage.po;
      delete data.eventMessage.port;
      delete data.eventMessage.transactionNumber;
      delete data.eventMessage.groupBy;
    }

    if (!searchApplied) {
      delete data.eventMessage.advanceSearchKey;
      if (country !== "canada") {
        delete data.eventMessage.startTime;
        delete data.eventMessage.endTime;
      }
    }

    return HttpClient.custom({
      data,
    });
  },

  validateBrokerHomePortCode: function (filerCode, portCode) {
    const data = {
      eventMessage: {
        userBasicInfo: {
          filerCode,
          portCode,
        },
      },
      eventType: "VALIDATE_BROKER_HOME_PORT_CODE",
      eventTime: Date.now(),
    };
    return HttpClient.custom({
      data,
    });
  },

  updateLicenseInfo: function (
    permitNumber,
    filerCode,
    portCode,
    businessNumber,
    countryOfBusiness
  ) {
    const data = {
      eventMessage: {
        userInfo: {
          brokerAdditionalInfo: {
            permitNumber,
            filerCode,
            portCode,
            businessNumber,
            countryOfBusiness
          },
        },
      },
      eventType: "KXUSER_UPDATE_LICENSE_INFO",
      eventTime: Date.now(),
    };
    return HttpClient.custom({
      data,
    });
  },

  cbpAuthorization: function (
    statementNumber,
    amount,
    filerCode,
    punNumber,
    portCode
  ) {
    const data = {
      eventType: "PAYMENT_CBP_AUTHORIZATION_REQUEST",

      eventMessage: {
        statementNumber: statementNumber,
        amount: amount,
        filerCode: filerCode,
        punNumber: punNumber,
        portCode: portCode,
      },
      eventTime: Date.now(),
    };
    return HttpClient.custom({
      data,
    });
  },

  getPUN: function (statementNumber) {
    const data = {
      eventType: "GET_PUN_NUMBER_INFO",

      eventMessage: {
        statementNumber: statementNumber,
      },
      eventTime: Date.now(),
    };
    return HttpClient.custom({
      data,
    });
  },

  cbpAuthStatus: function (statementNumber, filerCode) {
    const data = {
      eventType: "PAYMENT_CBP_GET_AUTHORIZATION_STATUS",

      eventMessage: {
        statementNumber: statementNumber,
        filerCode: filerCode,
      },
      eventTime: Date.now(),
    };
    return HttpClient.custom({
      data,
    });
  },


  getEDIMessage: function (statementNumber, ediType) {
    const data = {
      eventType: "GET_EDI_MESSAGE",

      eventMessage: {
        statementNumber: statementNumber,
        ediType: ediType,
      },
      eventTime: Date.now(),
    };
    return HttpClient.custom({
      data,
    });
  },

  getShipmentsForInvoice: function (pageNumber = 1) {
    const data = {
      eventType: "GET_SHIPMENTS_TO_INVOICE",

      eventMessage: {
        pageNumber: pageNumber,
      },
      eventTime: Date.now(),
    };
    return HttpClient.custom({
      data,
    });
  },

  generateInvoice: function (
    shipmentCharges,
    referenceText,
    brokerClearanceFee,
    customerEmail
  ) {
    const data = {
      eventMessage: {
        shipmentsChargesMap: shipmentCharges,
        referenceText: referenceText,
        brokerClearanceFee: brokerClearanceFee,
        customerEmail: customerEmail,
      },
      eventType: "GENERATE_INVOICE",
      eventTime: Date.now(),
    };

    return HttpClient.custom({
      data,
    });
  },

  getPastInvoices: function (pageNumber = 1, keyword = "", countryOfBusiness) {
    const data = {
      eventMessage: {
        pageNumber: pageNumber,
        keyword: keyword,
        countryName: countryOfBusiness,
      },
      eventType: "GET_MY_BROKER_INVOICES",
      eventTime: Date.now(),
    };

    return HttpClient.custom({
      data,
    });
  },

  updateProfile: function (profile, phone) {
    const data = {
      eventMessage: {
        userBasicInfo: {
          fullName: profile.fullName,
          displayImage: profile.profilePicture,
          ESigFileName: profile.ESigFileName,
          isESigApplied: profile.isESigApplied,
        },
        phone: [
          {
            typeOfPhone: phone.type,
            isdCode: phone.isdCode,
            phoneNo: phone.number,
          },
        ],
      },
      eventType: "KXUSER_UPDATE_EXISTING_PERSONAL_PROFILE",
      eventTime: Date.now(),
    };

    // Remove 'ProfilePicture' if none
    if (!profile.profilePicture)
      delete data["eventMessage"]["userBasicInfo"]["displayImage"];
    if (!profile.ESigFileName) {
      delete data["eventMessage"]["userBasicInfo"]["ESigFileName"];
      delete data["eventMessage"]["userBasicInfo"]["isESigApplied"];
    }

    return HttpClient.custom({
      data,
    });
  },

  resetPasswordEmail: function (body) {
    return HttpClient.custom({
      headers: getRequestHeadersNoToken(),
      data: body,
    });
  },

  validatePortCode: function (params) {
    let { cob, localFilingPortCode, filerCode } = params;
    const data = {
      eventMessage: {
        userBasicInfo: {
          filerCode: filerCode,
          portCode: localFilingPortCode,
        },
      },
      eventType: "VALIDATE_BROKER_HOME_PORT_CODE",
      eventTime: Date.now(),
    };

    return HttpClient.custom({
      data,
    });
  },

  // Need to keep companyAddress and companyInfo the same (until Alok can fix this issue)
  companyAddress: function (
    params,
    profilePicture,
    fileInput,
    uploadFile,
    updateUser
  ) {
    let {
      cob,
      companyName,
      businessName,
      address,
      address2,
      state,
      city,
      country,
      zip,
      entryNumberDetails,
      email
    } = params;
    const data = {
      eventMessage: {
        countryName: cob,
        ...(companyName
          ? {
            userBasicInfo: {
              companyName: companyName,
              displayImage: profilePicture ? profilePicture : null,
              accessToTs:"_BLANK_",
            },
          }
          : {
            userBasicInfo: {
              displayImage: profilePicture ? profilePicture : null,
              accessToTs:"_BLANK_",
            },
          }),
        userInfo: {
          companyInformation: {
            businessName: businessName,
            ...((cob === "SPAIN" || cob === "NETHERLANDS") ? { emailId: email } : null),
            businessAddress: [
              {
                type: "STREET_NUMBER",
                information: address,
              },
              {
                type: "STREET_NAME",
                information: address2,
              },
              {
                type: "COUNTRY_SUB_ENTITY",
                information: state,
              },
              {
                type: "CITY",
                information: city,
              },
              {
                type: "COUNTRY",
                information: country,
              },
              {
                type: "POSTAL_CODE",
                information: zip,
              },
            ],
          },
          ...(cob === "UNITED_STATES"
            ? {
              ...params.brokerAdditionalUS,
            }
            : null),
          ...(cob === "UNITED_KINGDOM"
            ? {
              ...params.brokerAdditional,
            }
            : null),
          ...(cob === "NETHERLANDS"
            ? {
              ...params.brokerAdditionalNL,
            }
            : null),
          ...(cob === "CANADA"
            ? {
              brokerAdditionalInfo: {
                ...params.brokerCA.brokerAdditionalInfo,
              },
            }
            : null),
          ...(cob === "SPAIN"
            ? {
              brokerAdditionalInfo: {
                ...params.brokerAdditional.brokerAdditionalInfo,
              },
            }
            : null),
        },
        ...(cob === "CANADA" || cob === "UNITED_STATES" || cob === "NETHERLANDS"
          ? { entryNumberDetails }
          : null),
      },

      eventType: "KXUSER_UPDATE_COMPANY_INFO",
      eventTime: Date.now(),
    };
    if (!profilePicture) {
      delete data["eventMessage"]["userBasicInfo"]["displayImage"];
    }

    console.log("profilePicture", profilePicture);
    const _fileInput = get(fileInput, "files", "");
    if (_fileInput.length > 0) {
      let file = _fileInput[0];

      uploadFile(file)
        .then((filename) => {
          data.eventMessage.userBasicInfo.displayImage = filename;

          updateUser(HttpClient, data, filename);

          // .then(async (updatedProfile) => {
          //   handleResponse(updatedProfile)

          // if (updatedProfile) {
          // shipmentApi
          //   .getSignedUrls({ bucket: window._env_.CUSTOMER_MEDIA_BUCKET, files: [filename] })
          //   .then((res) => {
          //     let url = get(res, "data.eventMessage.urls[0]", null);
          //     this.props.updateUserProfileImage(url);
          //     this.props.toggleModal("");
          //   })
          //   .catch((err) => console.log("Caught err during getSignedUrls: ", err));
          // }
          // })
          // .catch((err) => console.log("Caught error on updateUser: ", err));
        })
        .catch((err) => console.log("Caught error on uploadFile: ", err));
    } else {
      return HttpClient.custom({
        data,
      });

      // // this.props.toggleModal("");
      // this.setState({"statusMessage": "Form Saved!", formAlreadySubmitted: true}, () => {
      //   setTimeout(() => { this.setState({"statusMessage": ""}) }, 2000);
      // })
    }
    //  console.log('1111 hhhhh ::::', data)
    return HttpClient.custom({
      data,
    });
  },

  addPun: async function (pun) {
    const data = {
      eventMessage: {
        punInfo: {
          punNumber: pun,
        },
      },
      eventType: "PAYMENT_CREATE_PUN_INFO",
      eventTime: Date.now(),
    };
    const response = await HttpClient.custom({
      data,
    });
    let {code,msg}=response?.data?.eventMessage?.header || {}
    if(!msg){
      if(code==200){
        msg="Successfully saved"
        return
      }
        msg="Something went wrong"
    }
    showToast(msg)
    return response
  },

  deletePun: function (guid) {
    const data = {
      eventMessage: {
        punInfo: {
          paymentInstrumentGuid: guid,
        },
      },
      eventType: "PAYMENT_DELETE_PUN_INFO",
      eventTime: Date.now(),
    };
    return HttpClient.custom({
      data,
    });
  },

  getPaymentData: function () {
    const data = {
      eventMessage: {},
      eventType: "GET_PAYMENT_INSTRUMENTS",
      eventTime: Date.now(),
    };
    return HttpClient.custom({
      data,
    });
  },

  addTeamMember: function (
    email,
    typeOfUser,
    fullName,
    role,
    entrySummaryWrite,
    dailyStatementsWrite,
    invoiceWrite,
    adminAccount,
    phoneType,
    isdCode,
    phoneNo
  ) {
    const data = {
      eventMessage: {
        userBasicInfo: {
          companyName: "",
          email: email,
          typeOfUser: typeOfUser,
          fullName: fullName,
          role: role,
          userPrivileges: {
            userPrivilege: [
              {
                privilegeItem: "USER_PRIVILEGES_FILE_ENTRY_SUMMARY",
                write: entrySummaryWrite,
              },
              {
                privilegeItem: "USER_PRIVILEGES_AUTHORISE_CBP_PAYMENT",
                write: dailyStatementsWrite,
              },
              {
                privilegeItem: "USER_PRIVILEGES_GENERATE_INVOICE",
                write: invoiceWrite,
              },
              {
                privilegeItem: "USER_PRIVILEGES_IS_ADMIN_ACCOUNT",
                write: adminAccount,
              },
            ],
          },
        },
        phone: [
          {
            typeOfPhone: phoneType,
            isdCode: isdCode,
            phoneNo: phoneNo,
          },
        ],
      },
      eventType: "KXUSER_UPDATE_ADD_TEAM_MEMBER",
      eventTime: Date.now(),
    };

    return HttpClient.custom({
      data,
    });
  },
  reVerifyUser: function (email, role, contactName, typeOfUser) {
    const data = {
      eventMessage: {
        userBasicInfo: { email, role, contactName, typeOfUser },
      },
      eventType: "REVERIFY_TEAM_MEMBER",
      eventTime: Date.now(),
    };
    return HttpClient.custom({
      data,
    });
  },
  updateTeamMember: function (
    email,
    typeOfUser,
    fullName,
    role,
    entrySummaryWrite,
    dailyStatementsWrite,
    invoiceWrite,
    adminAccount,
    phoneType,
    isdCode,
    phoneNo
  ) {
    const data = {
      eventMessage: {
        userBasicInfo: {
          companyName: "",
          email: email,
          typeOfUser: typeOfUser,
          fullName: fullName,
          role: role,
          userPrivileges: {
            userPrivilege: [
              {
                privilegeItem: "USER_PRIVILEGES_FILE_ENTRY_SUMMARY",
                write: entrySummaryWrite,
              },
              {
                privilegeItem: "USER_PRIVILEGES_AUTHORISE_CBP_PAYMENT",
                write: dailyStatementsWrite,
              },
              {
                privilegeItem: "USER_PRIVILEGES_GENERATE_INVOICE",
                write: invoiceWrite,
              },
              {
                privilegeItem: "USER_PRIVILEGES_IS_ADMIN_ACCOUNT",
                write: adminAccount,
              },
            ],
          },
        },
        phone: [
          {
            typeOfPhone: phoneType,
            isdCode: isdCode,
            phoneNo: phoneNo,
          },
        ],
      },
      eventType: "KXUSER_UPDATE_TEAM_MEMBER",
      eventTime: Date.now(),
    };

    return HttpClient.custom({
      data,
    });
  },

  deleteTeamMember: function (email, typeOfUser) {
    const data = {
      eventMessage: {
        userBasicInfo: {
          email: email,
          typeOfUser: typeOfUser,
        },
      },
      eventType: "KXUSER_UPDATE_DELETE_TEAM_MEMBER",
      eventTime: Date.now(),
    };
    return HttpClient.custom({
      data,
    });
  },

  queryFunction: function (params, detailedRequest = "N") {
    let reqParam = {
      eventMessage: {
        detailedRequest: detailedRequest,
        ...params,
      },
      eventType: "FILE_ENTRY_SUMMARY_QUERY",
      eventTime: Date.now(),
    };
  },

  inviteChannelUser: function (email, type) {
    let data = {
      eventMessage: {
        email: email,
        typeOfUser: type,
        isDelete: false,
      },
      eventType: "CHANNEL_INVITE_USER",
      eventTime: Date.now(),
    };

    return HttpClient.custom({
      data,
    });
  },

  deleteChannelUser: function (email, type) {
    let data = {
      eventMessage: {
        email: email,
        typeOfUser: type,
        isDelete: true,
      },
      eventType: "CHANNEL_INVITE_USER",
      eventTime: Date.now(),
    };

    return HttpClient.custom({
      data,
    });
  },

  getLangBundleByNamespc: function (language, namespace) {
    let data = {
      "eventMessage": {
        "language": language,
        "namespace": namespace
      },
      "eventType": "I18N_GET_NAMESPACE_AND_LANGUAGE",
      "eventTime": 1647004919910
    }
    return HttpClient.custom({
      data
    })
  },

  approveChannelUser: function (email) {
    let data = {
      eventMessage: {
        email: email,
        approved: true,
      },
      eventType: "CHANNEL_APPROVE_USER",
      eventTime: Date.now(),
    };

    return HttpClient.custom({
      data,
    });
  },

  addAdditionalFeeInvoice: function (shipmentId, chargeDescription, charge) {
    let data = {
      eventMessage: {
        shipmentId: shipmentId,
        chargeDescription: chargeDescription,
        charge: charge,
      },
      eventType: "ADD_ADDITIONAL_DUTIES",
      eventTime: Date.now(),
    };

    return HttpClient.custom({
      data,
    });
  },

  deleteAdditionalFeeInvoice: function (
    shipmentId,
    chargeId,
    chargeDescription,
    charge
  ) {
    let data = {
      eventMessage: {
        shipmentId: shipmentId,
        chargeId: chargeId,
        chargeDescription: chargeDescription,
        charge: charge,
      },
      eventType: "DELETE_ADDITIONAL_CHARGES",
      eventTime: Date.now(),
    };

    return HttpClient.custom({
      data,
    });
  },

  updatePaymentSchedule: function (paymentSchedule) {
    let data = {
      eventMessage: {
        paymentGroupSettings: {
          kxFeePaymentInstrumentGuid: null,
          cbpDuesPaymentInstrumentGuid: null,
          otherFeePaymentInstrumentGuid: null,
          cbpDuesPaymentCode: paymentSchedule,
        },
      },
      eventType: "PAYMENT_UPDATE_GROUP_SETTINGS",
      eventTime: Date.now(),
    };

    return HttpClient.custom({
      data,
    });
  },

  getActorList: (actorType, pageNum) => {
    let data = {
      eventMessage: {
        actorType: actorType,
        pageNumber: pageNum,
      },
      eventType: "GET_ACTOR_REFS",
      eventTime: Date.now(),
    };
    return HttpClient.custom({
      data,
    });
  },

  createActorRef: function (mfData, updatedBy, savedInContextOf) {
    let streetNum = "";
    let streetName = "";
    if (mfData.street) {
      let street = mfData.street.trim().split(" ");
      streetNum = street[0].trim();
      streetName = street.slice(1).join(" ").trim();
    }
    let data = {
      eventMessage: {
        actorType: "1",
        name: mfData.name,
        countryCode: mfData.countryCode,
        city: mfData.city,
        state: mfData.state,
        postalCode: mfData.zip,
        streetNumber: streetNum,
        streetName: " " + streetName.trimLeft(),
        mid: mfData.mid,
        unstructuredAddress: mfData.unstructuredAddress,
        contactName: mfData.contactName,
        email: mfData.email,
        actorEmail: mfData.email,
        primaryPhone: mfData.primaryphone,
        primaryphone: mfData.primaryphone,
        lastUpdatedBy: updatedBy,
        savedInContextOf: savedInContextOf,
      },
      eventType: "CREATE_ACTOR_REF",
      eventTime: Date.now(),
    };
    return HttpClient.custom({
      data,
    });
  },
  archiveActorRef: function (mid) {
    let data = {
      eventMessage: mid,
      eventType: "ARCHIVE_ACTOR_REF_BY_MID",
      eventTime: Date.now(),
    };
    return HttpClient.custom({
      data,
    });
  },
  getImporterList: function (filerCode = "") {
    let data = {
      eventMessage: {
        value: filerCode,
      },
      eventType: "GET_IMPORTER_MAP",
      eventTime: Date.now(),
    };
    return HttpClient.custom({
      data,
    });
  },
  deleteStatementEnteries: function (key, value) {
    const data = {
      eventType: "DELETE_STATEMENT_ENTRIES",
      eventMessage: {
        entryNumbers: [
          {
            key,
            value: {
              value,
            },
          },
        ],
      },
      eventTime: Date.now(),
    };
    return HttpClient.custom({
      data,
    });
  },
  getTransactionByResponseId: function (countryCode, responseId) {
    let eventParam = "EU";
    if(countryCode === "CA"){
      eventParam = "CARM"
    }
    let data = {
      eventMessage: {
        "countryCode": countryCode,
        "responseFormat": "XML",
        "responseId": responseId
      },
      eventType: `GET_TRANSACTION_RESPONSE_${eventParam}_BY_ID`,
      eventTime: Date.now(),
    };
    return HttpClient.custom({
      data,
    })
  },
  getTransactionByRequestId: function (countryCode, requestId) {
    let eventParam = "EU";
    if (countryCode === "CA") {
      eventParam = "CARM"
    }
    let data = {
      eventMessage: {
        "countryCode": countryCode,
        "responseFormat": "XML",
        "requestId": requestId
      },
      eventType: `GET_TRANSACTION_REQUEST_${eventParam}_BY_ID`,
      eventTime: Date.now(),
    };
    return HttpClient.custom({
      data,
    })
  },

  xmlReviewByShipId: function (shipmentId, formType) {
    let data = {
      eventMessage: {
        "shipmentId": shipmentId,
        "formType": formType,
        "cds": {
          previewXml: true
        }
      },
      eventType: "FILE_FORM_GB",
      eventTime: Date.now(),
    };
    return HttpClient.custom({
      data,
    })
  },

  xmlSentByShipId: function (countryCode, shipmentId) {
    let data = {
      eventMessage: {
        "countryCode": countryCode,
        "shipmentId": shipmentId,
      },
      eventType: "GET_LATEST_TRANSACTION_REQUEST_EU",
      eventTime: Date.now(),
    };
    return HttpClient.custom({
      data,
    })
  }
}
